import React, { useEffect } from 'react'
import { Layout } from '@components/layout/Layout'
// import { AUTH_SIGN_UP } from '@constants'
import './index.sass'
import { Link } from 'react-router-dom'
import {
	PWA_PAGE,
	PWA_MACOSPAGE,
	SUPPORT_PAGE,
	FAQ_PAGE,
} from '../../../constants'
import logo01 from '@assets/images/main/payment-logo01.svg'
import logo02 from '@assets/images/main/payment-logo02.svg'
import logo03 from '@assets/images/main/payment-logo03.svg'
import logo04 from '@assets/images/main/payment-logo04.svg'
import logo05 from '@assets/images/main/payment-logo05.svg'
import logo06 from '@assets/images/main/payment-logo06.svg'
import logo07 from '@assets/images/main/payment-logo07.svg'


const win32 = '/setups/Cronika-Setup-1.0.0-x32.exe'
const win64 = '/setups/Cronika-Setup-1.0.0-x64.exe'
const apk = '/setups/application.apk'
const debFile = '/setups/Cronika-1.0.0.deb'
const logos = [logo01, logo02, logo03, logo04, logo05, logo06, logo07]
const hostname = window.location.hostname; 
const parts = hostname.split('.');

let baseDomain = '';

if (parts.length === 2) {
  baseDomain = hostname; 
} else if (parts.length > 2) {
  baseDomain = parts.slice(-2).join('.'); 
}

const signupUrl = `https://app.${baseDomain}/auth/signup`; 
export const Main = () => {
	useEffect(() => {
		document.body.classList.add('main-page')
		return () => {
			document.body.classList?.remove('main-page')
		}
	}, [])

	return (
		<Layout>
			<div className='basic-main home-main'>
				<div className='title-section'>
					<div className='container'>
						<div className='title-box'>
							<figure className='title-logo'>
								<img
									src={require('@assets/images/main/title-logo.png')}
									alt='logo'
								/>
							</figure>
							<div className='title-info'>
								<h1 className='large-title'>
									Simple format. Transparent terms. Real trading.
								</h1>
								<p>
									Simple doesn’t mean basic. We made trading understandable
									without losing clarity or control.
								</p>
								{/* <Link className='basic-button' to={AUTH_SIGN_UP}>
									Get Started
								</Link> */}
								<a
									className='basic-button'
									href={signupUrl}
								>
									Get Started
								</a>
							</div>
						</div>
					</div>
					<div className='currency-section'>
						<div className='currency-row'>
							<ul>
								<li>UPI 9%</li>
								<li>IMPS 9%</li>
								<li>JazzCash 8%</li>
								<li>NEFT 9%</li>
								<li>RTGS 9%</li>
								<li>EasyPaisa 8%</li>
							</ul>
						</div>
					</div>
				</div>

				<div className='container'>
					<div className='scan-section'>
						<img
							src={require('@assets/images/main/scan-img01.png')}
							alt='img'
						/>
						<img
							src={require('@assets/images/main/scan-img02.png')}
							alt='img'
						/>
						<img
							src={require('@assets/images/main/scan-img03.svg').default}
							alt='img'
						/>
						<img
							src={require('@assets/images/main/scan-img04.png')}
							alt='img'
						/>
						<div className='scan-box'>
							<div className='scan-flex'>
								<div className='col'>
									<a className='basic-logo' href='#'>
										<img
											src={
												require('@assets/images/main/basic-logo.svg').default
											}
											alt='logo'
										/>
									</a>
									<figure className='scan'>
										<img
											src={require('@assets/images/main/new_qr.png')}
											alt='img'
										/>
									</figure>
								</div>
								<div className='col'>
									<h2>
										<mark>Trade</mark> from anywhere!
									</h2>
									<p>
										You can trade anytime and anywhere with the Cronika app for{' '}
										<b>IOS and Android</b>. Stay in the know: instant
										information on trade closings, promotions and tournaments.
									</p>
								</div>
							</div>
							<div className='scan-logos'>
								<Link to={PWA_PAGE}>
									<img
										src={
											require('@assets/images/pwa/pwa-for-android.svg').default
										}
										alt='logo'
									/>
								</Link>
								<Link to={PWA_PAGE}>
									<img
										src={require('@assets/images/pwa/pwa-for-ios.svg').default}
										alt='logo'
									/>
								</Link>
								<a
									target='_blank'
									href='https://t.me/CronikaLiveBot'
								>
									<img
										src={require('@assets/images/main/tg-mini-app.svg').default}
										alt='logo'
									/>
								</a>

								<a	className='ubuntu'
									target='_blank'
									href={debFile}
									download
								>
<svg viewBox="0 0 1772.0 548.0" fill="none" preserveAspectRatio="xMidYMid meet">
<g transform="translate(100, 50)">
<path d="M364.6 0C368.2 1.9 372.2 1.8 376 2.7C419.8 13.4 450.5 52.2 450.5 97C450.6 182.3 450.6 267.5 450.5 352.8C450.5 397.8 419.4 436.9 375.5 447.2C373.3 447.7 371.2 447.8 369.1 447.8C273.2 447.8 177.2 447.8 81.3 447.8C70.7 447.8 61.1 443.7 52.1 438.7C19 420.1 0.500015 392 0.300015 353.8C-0.199985 267.9 1.50353e-05 181.9 0.200015 96C0.300015 47.9 36.1 7.6 83.8 1C84.6 0.9 85.5 1 85.9 0C178.8 0 271.7 0 364.6 0ZM287.2 285.9C260.9 285.6 239.2 306.6 239 332.8C238.7 358.8 259.8 380.4 285.7 380.8C312.2 381.2 334.1 359.9 334.2 333.6C334.3 307.5 313.3 286.2 287.2 285.9ZM344.8 106.4C344.7 80.2 323.1 58.9 296.9 59.1C270.9 59.3 249.7 80.7 249.7 106.6C249.7 132.8 271 154 297.4 154.1C323.7 154.1 344.9 132.7 344.8 106.4ZM51.7 210.6C51.7 236.9 72.9 258.2 99.2 258.2C125.4 258.2 146.8 236.8 146.8 210.6C146.8 184.6 125.6 163.4 99.5 163.3C73 163.3 51.7 184.4 51.7 210.6ZM360.3 134.2C354.7 146.4 346.6 156.2 335.6 163.6C333.2 165.2 335 166.8 335.7 168.3C352.7 205.3 351.5 241.6 331.8 277.3C330.3 280 330.9 281.2 332.9 283C339.7 289 344.9 296.3 348.7 304.6C350.2 308 351.5 311.5 353 315.1C397.1 260.8 395.2 182.9 360.3 134.2ZM86.8 278C101 311.4 122.9 336.5 153.3 354C177.4 367.9 203.4 374.5 231.9 374.6C224 363.4 219.2 352 218.5 339.3C218.3 335.5 216.7 334.6 213.4 334.2C206.1 333.4 199 331.5 192.1 329C164.7 319.2 143.7 301.6 129.2 276.3C128.4 274.9 128.2 272.4 125.4 273.6C113.4 278.8 100.8 280 86.8 278ZM243 64.4C208.3 62.3 176.9 70.1 148.1 88C126.2 101.6 108.9 119.7 95.6 142.6C109.5 142.3 121.7 145.1 132.9 151.6C135.3 153 136 151.6 137.2 150.1C158.5 122.1 186.7 106.4 221.8 103.4C227.1 102.9 229 101.7 229.5 96.2C230.7 84.7 235.7 74.4 243 64.4Z" fill="#E9500E"/>
<path d="M841.9 189C852.5 183.1 862.8 178.7 874.2 177.2C914.9 171.8 946.7 194.2 955 234.4C959.5 256.2 959.1 277.8 950 298.4C937.6 326.4 915 340.1 884.9 341.8C865 342.9 845.4 340.6 826.2 334.8C823 333.8 821.9 332.6 821.9 329C822 255.6 822 182.1 821.9 108.7C821.9 104.9 822.9 103.4 826.7 103.2C830.3 103 834 102.2 837.5 101.2C841.1 100.1 842.1 101.1 842 104.8C841.8 120.6 841.9 136.4 841.9 152.1C841.9 164.2 841.9 176.1 841.9 189ZM841.9 263.7C841.9 281 842 298.3 841.8 315.6C841.8 319 843 320.3 846.1 320.9C858.7 323.4 871.5 324.8 884.3 323.8C905.5 322.1 921.7 312.2 930.2 292.3C938.2 273.6 937.7 254.1 933.5 234.6C929.9 218.2 921.6 204.7 905.2 198.6C883.5 190.4 863.1 195 844 207.3C841.7 208.8 841.9 210.8 841.9 212.9C841.9 229.8 841.9 246.8 841.9 263.7Z" fill="white"/>
<path d="M773.4 199.8C773.4 220.6 773.5 241.3 773.4 262.1C773.3 275 771.5 287.6 766.8 299.7C758.3 321.6 742.4 335.3 719.4 340.4C702.2 344.2 684.9 344.2 668 339.4C640.5 331.5 625.9 311.9 620.4 284.7C618.7 276.2 618 267.6 618 258.9C618 216.2 618.1 173.5 617.9 130.8C617.9 127 618.7 125.4 622.8 125.9C628 126.5 634.9 123.7 638.1 127.1C641.1 130.2 638.9 136.9 638.9 142C639 180.5 638.9 219.1 638.9 257.6C638.9 268.8 640.3 279.8 644.2 290.3C652 311.5 667.7 322.1 689.8 324C699.7 324.8 709.5 323.7 718.8 320.2C734.5 314.3 743.4 302.2 748.3 286.7C751.2 277.4 752.4 267.9 752.4 258.2C752.3 216 752.4 173.8 752.3 131.6C752.3 127.3 753 125.3 757.9 125.8C762.8 126.3 769.5 124.2 772.3 126.7C775.5 129.6 773.3 136.4 773.3 141.4C773.5 161 773.4 180.4 773.4 199.8Z" fill="white"/>
<path d="M1118.3 256.6C1118.3 280.4 1118.1 304.1 1118.4 327.9C1118.5 332.3 1116.8 333.4 1113.1 334.3C1093.5 339.3 1073.7 342 1053.4 341.3C1020.3 340.2 1000.3 322.2 996.1 289.3C995 280.9 994.5 272.4 994.6 264C994.6 237.6 994.7 211.2 994.5 184.8C994.5 181.2 995.1 179.6 999.1 180C1004 180.4 1010.7 178.4 1013.6 180.9C1017 183.8 1014.6 190.6 1014.7 195.6C1014.9 222.2 1015 248.8 1015.2 275.3C1015.2 281.1 1016.1 286.9 1017.5 292.5C1022.3 312.1 1032.9 321.3 1053 323C1066.5 324.1 1079.9 322.9 1093.2 320.5C1097.1 319.8 1098.5 318.3 1098.5 314C1098.3 271.1 1098.5 228.3 1098.3 185.4C1098.3 180.6 1099.8 179.4 1104.1 179.8C1107.4 180.1 1110.8 180.1 1114.1 179.8C1117.8 179.4 1118.4 180.9 1118.4 184.3C1118.3 208.4 1118.3 232.5 1118.3 256.6Z" fill="white"/>
<path d="M1165.4 261.7C1165.4 237.6 1165.4 213.5 1165.3 189.4C1165.3 186.8 1165.7 185.2 1168.6 184.4C1190.7 178.9 1212.9 175.4 1235.7 177.2C1264.1 179.5 1282 195.7 1286.7 223.6C1288.2 232.5 1289 241.4 1289 250.4C1288.9 278.1 1288.9 305.9 1289.1 333.6C1289.1 337.3 1288.3 338.6 1284.5 338.2C1281.2 337.8 1277.8 337.8 1274.5 338.2C1270.3 338.6 1268.9 337.5 1268.9 332.9C1269.2 306.5 1269 280.1 1269 253.7C1269 242.5 1268.2 231.5 1264.9 220.7C1260.4 205.7 1250.2 197.4 1234.8 195.6C1219.6 193.9 1204.6 195.1 1189.6 197.9C1186.1 198.5 1185.2 200.1 1185.2 203.6C1185.3 246.6 1185.2 289.7 1185.4 332.7C1185.4 337.4 1184.1 338.8 1179.6 338.3C1176.5 338 1173.3 338 1170.1 338.3C1166.3 338.7 1165 337.5 1165.1 333.5C1165.5 309.6 1165.4 285.7 1165.4 261.7Z" fill="white"/>
<path d="M1571.6 257C1571.6 280.9 1571.6 304.9 1571.7 328.8C1571.7 331.7 1571 333.2 1568 334C1547.2 339.2 1526.3 342.2 1504.8 341.3C1474.3 340 1454.6 322.7 1449.9 292.4C1448.5 283.5 1447.8 274.6 1447.9 265.6C1448 238.7 1448 211.8 1447.8 184.8C1447.8 180.9 1448.8 179.5 1452.7 179.9C1457.6 180.4 1464.2 177.8 1467 180.9C1469.4 183.6 1467.7 190.1 1467.8 194.9C1467.8 218.3 1467.8 241.8 1467.8 265.2C1467.8 273.9 1468.6 282.5 1470.4 290.9C1474.6 311.1 1485.2 320.9 1505.6 322.9C1519.6 324.2 1533.5 322.9 1547.3 320.3C1550.7 319.7 1551.7 318.2 1551.7 314.7C1551.6 271.5 1551.7 228.3 1551.5 185.1C1551.5 181 1552.4 179.4 1556.6 179.9C1559.7 180.3 1562.9 180.2 1566.1 179.9C1570.3 179.5 1571.8 180.6 1571.7 185.2C1571.5 209.1 1571.6 233 1571.6 257Z" fill="white"/>
<path d="M1333.8 214.1C1333.8 188.7 1333.9 163.3 1333.7 137.9C1333.7 134.5 1334.3 132.8 1338.1 132.5C1342.1 132.2 1346 131.4 1349.9 130.4C1353.2 129.5 1353.8 130.4 1353.8 133.5C1353.7 147.5 1353.9 161.4 1353.6 175.4C1353.5 179 1354.3 180.1 1358.2 180.1C1376.2 179.9 1394.1 180.1 1412.1 179.9C1416.2 179.8 1417.3 181.1 1416.9 184.9C1416.5 188.7 1418.1 193.7 1416.2 195.9C1413.9 198.5 1408.7 196.7 1404.8 196.7C1389.2 196.8 1373.5 196.8 1357.9 196.7C1354.7 196.7 1353.7 197.4 1353.7 200.8C1353.8 229 1353.8 257.3 1353.8 285.5C1353.8 291.5 1354.6 297.4 1356.1 303.2C1359.4 315.8 1366.2 321.6 1379.1 323.1C1391.8 324.6 1404 323 1415.4 316.9C1418 315.5 1419.1 315.7 1419.8 318.6C1420.4 321.3 1421 324.2 1422.2 326.7C1424.1 330.8 1422.9 332.6 1418.8 334.4C1401.2 342 1383.2 343.8 1364.7 339C1349.3 335 1340.7 324.3 1336.9 309.4C1334.6 300.3 1333.8 291.1 1333.8 281.7C1333.8 259.3 1333.8 236.7 1333.8 214.1Z" fill="white"/>
<path d="M287.2 285.9C313.3 286.2 334.2 307.5 334.1 333.6C334 359.9 312.1 381.2 285.6 380.8C259.7 380.4 238.7 358.8 238.9 332.8C239.3 306.6 260.9 285.6 287.2 285.9Z" fill="#FEFEFE"/>
<path d="M344.8 106.4C344.9 132.7 323.6 154.1 297.4 154.1C271.1 154.1 249.7 132.9 249.7 106.6C249.7 80.6 270.9 59.3 296.9 59.1C323.2 58.9 344.7 80.2 344.8 106.4Z" fill="#FEFEFE"/>
<path d="M51.7001 210.6C51.7001 184.3 73.0001 163.3 99.4001 163.3C125.5 163.4 146.6 184.5 146.7 210.6C146.7 236.8 125.3 258.2 99.1001 258.2C72.9001 258.3 51.7001 237 51.7001 210.6Z" fill="#FEFEFE"/>
<path d="M360.3 134.2C395.2 182.9 397.1 260.8 352.9 315.1C351.4 311.5 350.2 308 348.6 304.6C344.9 296.3 339.6 289.1 332.8 283C330.7 281.2 330.2 279.9 331.7 277.3C351.4 241.7 352.6 205.3 335.6 168.3C334.9 166.8 333.1 165.2 335.5 163.6C346.6 156.3 354.8 146.4 360.3 134.2Z" fill="#FEFEFE"/>
<path d="M86.8 278C100.8 280 113.4 278.8 125.5 273.7C128.3 272.5 128.5 275 129.3 276.4C143.8 301.6 164.8 319.2 192.2 329.1C199.1 331.6 206.2 333.5 213.5 334.3C216.7 334.7 218.3 335.6 218.6 339.4C219.3 352.2 224.1 363.6 232 374.7C203.5 374.6 177.5 367.9 153.4 354.1C122.9 336.4 101 311.4 86.8 278Z" fill="#FEFEFE"/>
<path d="M243 64.4002C235.7 74.4002 230.7 84.7002 229.6 96.3002C229.1 101.8 227.1 103 221.9 103.5C186.8 106.5 158.6 122.2 137.3 150.2C136.2 151.7 135.5 153.1 133 151.7C121.8 145.2 109.6 142.4 95.7 142.7C109 119.8 126.3 101.7 148.2 88.1002C176.9 70.0002 208.2 62.3002 243 64.4002Z" fill="#FEFEFE"/>
</g>
</svg>
								</a>

								<a
									target='_blank'
									href={apk}
									download
								>
									<img
										src={require('@assets/images/main/android-apk.svg').default}
										alt='logo'
									/>
								</a>
							</div>
						</div>
					</div>
				</div>

				<figure className='main-img'>
					<img
						className='desktop'
						src={require('@assets/images/main/33.jpg')}
						alt='img'
					/>
					<img
						className='mobile'
						src={require('@assets/images/main/33.jpg')}
						alt='img'
					/>
				</figure>

				<div className='container'>
					<div className='desktop-section section'>
						<h2>Desktop</h2>
						<p>
							Enjoy a smooth trading experience with <br />
							the Cronika trading app.
						</p>
						<div className='desktop-box'>
							<a
								href={win64}
								download
								target='_blank'
							>
								<figure className='desktop-icon'>
									<img
										src={
											require('@assets/images/main/windows-icon.svg').default
										}
										alt='icon'
									/>
								</figure>
								Windows x64
							</a>

							<a
								href={win32}
								download
								target='_blank'
							>
								<figure className='desktop-icon'>
									<img
										src={
											require('@assets/images/main/windows-icon.svg').default
										}
										alt='icon'
									/>
								</figure>
								Windows x32
							</a>

							<Link
								to={PWA_MACOSPAGE}
							>
								<figure className='desktop-icon'>
									<img
										src={require('@assets/images/main/mac-icon.svg').default}
										alt='icon'
									/>
								</figure>
								Mac PWA
							</Link>
						</div>
					</div>

					<h2>
						Cronika is designed with ease <br />
						of use in mind
					</h2>
					<div className='instruments-box'>
						<div className='box'>
							<img
								src={require('@assets/images/main/instrument-bg01.png')}
								alt='img'
							/>
							<h3>New here? We’ll walk you through.</h3>
							<Link to={SUPPORT_PAGE}>Learn more</Link>
						</div>
						<div className='box'>
							<img
								src={require('@assets/images/main/instrument-bg02.png')}
								alt='img'
							/>
							<h3>
								Plan your exit:{' '}
								<mark>
									Trade <br />
									closure at predefined profit <br />
									or loss levels
								</mark>
							</h3>
						</div>
						<div className='box'>
							<img
								src={require('@assets/images/main/instrument-bg03.png')}
								alt='img'
							/>
							<h3>Quick answers to the things you care about.</h3>
							<Link to={FAQ_PAGE}>Learn more</Link>
						</div>
						<div className='box'>
							<img
								src={require('@assets/images/main/instrument-bg04.png')}
								alt='img'
							/>
							<h3>
								Trade with confidence: <span className='toggle-icon'></span>
								<br />
								<mark>
									negative balance protection <br />
									caps your risk
								</mark>
							</h3>
						</div>
					</div>

					<div className='about-box section'>
						{/* <h2>Cronika is a licensed and <br />regulated online broker</h2>
            <figure className="about-logos">
              <img src={require("@assets/images/main/about-logos.jpg")} alt="logos" />
            </figure> */}
						{/* <Link to={AUTH_SIGN_UP} className='basic-button'>
							Get Started
						</Link> */}
						<a
							className='basic-button'
							href={signupUrl}
						>
							Get Started
						</a>
					</div>

					<div className='payment-section section'>
						<h2>Quick and easy withdrawals through local solutions</h2>
						<div className='payment-box'>
							{logos.map((logo, i) => (
								<a className='box' key={i}>
									<img src={logo} alt={`logo${i + 1}`} />
								</a>
							))}
						</div>
					</div>

					<div className='reviews-box'>
						<div className='title-review'>
							<div className='basic-logo'>
								<img
									src={require('@assets/images/main/basic-logo.svg').default}
									alt='logo'
								/>
							</div>
							<h2>Verified by trading enthusiasts around the world</h2>
						</div>
						<div className='review-item'>
							<ul className='rating'>
								{[...Array(5)].map((_, i) => (
									<li key={i}></li>
								))}
							</ul>
							<p>Very simple to set up and earn</p>
							<p>Top software for trading</p>
							<div className='review-author'>
								<figure className='author-photo'>
									<img
										src={require('@assets/images/main/support-img.jpg')}
										alt='photo'
									/>
								</figure>
								<span className='author-name'>
									Nikolas F. <br />
									Trader & Crypto enthusiast
								</span>
							</div>
						</div>
					</div>

					<figure className='footer-img'>
						<img
							src={require('@assets/images/main/footer-img.png')}
							alt='img'
						/>
					</figure>
				</div>
			</div>
		</Layout>
	)
}

export default Main
